import { ESdChangeReason, IHelpdeskLimits, IHelpdeskTicketContext } from "@kuika/kuika-cl-model";
import React from "react";
import { withSD } from "../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../shared/pure-sd";
import { buildHelpdeskTicketContext } from "./helpdesk-ticket-context";
import ItsmHelpdesk from "./itsm-helpdesk";

export interface IItsmHelpdeskConnectedProps {
  limits: IHelpdeskLimits;
  startWithNewTicket?: boolean;
}

/** Binds the ITSM helpdesk to the signed-in user and the designer state (badge, app/screen context). */
class ItsmHelpdeskConnected extends PureSdComponent<IItsmHelpdeskConnectedProps & IWithContextProp, object> {
  // Read lazily: a ticket records the app and screen the user is on when they start it.
  getTicketContext = (): IHelpdeskTicketContext => buildHelpdeskTicketContext(this.props.sd);

  onUnreadChanged = (): void => {
    this.props.sd.getTicketNotifyCount();
  };

  render(): React.ReactNode {
    const { context, limits, startWithNewTicket } = this.props;
    return (
      <ItsmHelpdesk
        userId={context?.userInfo?.id}
        workspaceName={context?.userInfo?.lastUsedDomainName}
        limits={limits}
        startWithNewTicket={startWithNewTicket}
        getTicketContext={this.getTicketContext}
        onUnreadChanged={this.onUnreadChanged}
      />
    );
  }

  // The helpdesk keeps its own state; designer changes never need to re-render it.
  checkNeedRender = (_changeReason: ESdChangeReason): boolean => false;
}

const itsmHelpdeskConnected = withContext<IItsmHelpdeskConnectedProps>(
  withSD<IItsmHelpdeskConnectedProps>(ItsmHelpdeskConnected)
);
export { itsmHelpdeskConnected as ItsmHelpdeskConnected };
